import React, { useState } from 'react';
import { graphql } from 'gatsby';
import Button from 'components/Core/Button';
import MarketoForm from 'components/Form/MarketoForm';
import RegistrationOptions from './RegistrationOptions';
import { PantheonModalRegistration, FormTitle } from './styles';
import { navigate, useStaticQuery } from 'gatsby';

const PantheonRegistration = () => {
  const [isModalVisible, toggleIsModalVisible] = useState(false);
  const [isDemoFormVisible, toggleIsDemoFormVisible] = useState(false);

  const inlineMarketingForm = useStaticQuery(graphql`
    query {
      contentfulInlineMarketingForm(internalName: { eq: "Pantheon Registration Form" }) {
        ...InlineMarketingForm
      }
    }
  `).contentfulInlineMarketingForm;

  const closeModal = () => {
    toggleIsModalVisible(false);
  };

  const register = () => {
    toggleIsDemoFormVisible(true);
  };

  const navigateToRegistration = () => {
    navigate('/pantheon/registration');
  };

  const title = (
    <FormTitle>
      <button
        data-position="Form - CTA"
        type="button"
        onClick={() => toggleIsDemoFormVisible(false)}
        class="slick-prev"
      ></button>
      <div className="pantheon-registration--form-title">{inlineMarketingForm?.formTitle}</div>
    </FormTitle>
  );

  return (
    <>
      <Button type="secondary" onClick={() => toggleIsModalVisible(!isModalVisible)}>
        Register Now
      </Button>
      <PantheonModalRegistration
        visible={isModalVisible}
        onOk={closeModal}
        onCancel={closeModal}
        afterClose={() => toggleIsDemoFormVisible(false)}
        centered
        closable={false}
        footer={null}
        isDemoFormVisible={isDemoFormVisible}
      >
        {!isDemoFormVisible ? (
          <RegistrationOptions
            register={register}
            navigateToRegistration={navigateToRegistration}
          />
        ) : (
          <MarketoForm
            title={title}
            inlineMarketingForm={inlineMarketingForm}
            buttonLabel="Continue"
            customDQ={{
              qualified: 'thankyou-pantheon',
              disqualified: 'pantheon/registration-pricing',
            }}
          />
        )}
      </PantheonModalRegistration>
    </>
  );
};

export default PantheonRegistration;
